import { CountryDataResponse } from "@/data-types/api/countryData.types";
import { INITIAL_LOC_CODE } from "config/config";
import getForm from "./form";

const {
  formField: {
    country,
    year,
    ageIntervalStart1,
    ageIntervalStart2,
    ageIntervalStart3,
    ageIntervalStart4,
    ageIntervalMid1,
    ageIntervalMid2,
    ageIntervalMid3,
    ageIntervalMid4,
    incidenceScalingAge1,
    incidenceScalingAge2,
    incidenceScalingAge3,
    incidenceScalingAge4,
    survivalLastYearAge1,
    survivalLastYearAge2,
    survivalLastYearAge3,
    survivalLastYearAge4,
    incidenceRateFirstYear,
    incidenceRateLastYear,
    startYearInsulin,
    lifeExpectancy,
    incidenceRateScaling,
    cumulativesSurvAge1,
    cumulativesSurvAge2,
    cumulativesSurvAge3,
    cumulativesSurvAge4,
    cumulativesInc,
  },
} = getForm();

export const getInitialValues = (values: CountryDataResponse, locCode?: number): any => {
  const IDFStandRate0_19 = values?.country_IDFStandRate0_19;
  const incidenceRateLastYearValue = IDFStandRate0_19 ? IDFStandRate0_19 * 1.05 : null;
  const incidenceRateFirstYearValue = incidenceRateLastYearValue
    ? incidenceRateLastYearValue * 0.15
    : null;

  return {
    [country.name]: locCode ?? INITIAL_LOC_CODE,

    [year.name]: new Date().getFullYear(),

    [ageIntervalStart1.name]: 0,
    [ageIntervalStart2.name]: 20,
    [ageIntervalStart3.name]: 40,
    [ageIntervalStart4.name]: 60,

    [ageIntervalMid1.name]: 9,
    [ageIntervalMid2.name]: 28,
    [ageIntervalMid3.name]: 48,
    [ageIntervalMid4.name]: 70,

    [survivalLastYearAge1.name]: values?.country_RelSurv1yr0_19,
    [survivalLastYearAge2.name]: values?.country_RelSurv1yr20_39,
    [survivalLastYearAge3.name]: values?.country_RelSurv1yr40_59,
    [survivalLastYearAge4.name]: values?.country_RelSurv1yr60Plus,

    [incidenceScalingAge1.name]: 1,
    [incidenceScalingAge2.name]: values?.country_RelInc20_39,
    [incidenceScalingAge3.name]: values?.country_RelInc40_59,
    [incidenceScalingAge4.name]: values?.country_RelInc60Plus,

    [incidenceRateLastYear.name]: incidenceRateLastYearValue,
    [incidenceRateFirstYear.name]: incidenceRateFirstYearValue,

    [startYearInsulin.name]: values?.country_YearInsulin,
    [lifeExpectancy.name]: values?.country_LifeExp,

    [incidenceRateScaling.name]: 100000,

    [cumulativesSurvAge1.name]: values?.knotSurv0
      ? [...values.knotSurv0, values?.country_RelSurv1yr0_19]
      : Array(10).fill(null),
    [cumulativesSurvAge2.name]: values?.knotSurv20
      ? [...values.knotSurv20, values?.country_RelSurv1yr20_39]
      : Array(10).fill(null),
    [cumulativesSurvAge3.name]: values?.knotSurv40
      ? [...values.knotSurv40, values?.country_RelSurv1yr40_59]
      : Array(10).fill(null),
    [cumulativesSurvAge4.name]: values?.knotSurv60
      ? [...values.knotSurv60, values?.country_RelSurv1yr60Plus]
      : Array(10).fill(null),

    [cumulativesInc.name]: values?.knotInc ?? Array(14).fill(null),
  };
};

export default getInitialValues;
